import AppLayout from "@/layouts/AppLayout";
import TabLayout from "./_TabLayout";
import { DOMAIN, PERMISSION, useRequireCapability } from "@/hooks/useCapabilities";
import PageHeading from "@/components/PageHeading";
import JobsTabs from "./_JobsTabs";
import usePageTitle from "@/hooks/usePageTitle";

export default function JobsPage() {
  usePageTitle("/jobs", "Jobs");
  useRequireCapability({ domain: DOMAIN.JOBS, permission: PERMISSION.viewJobPosts });

  return (
    <AppLayout navLinks={[]} interior bottomBar>
      <PageHeading title="Jobs" />
      <TabLayout>
        <JobsTabs />
      </TabLayout>
    </AppLayout>
  );
}
